import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-all duration-300"
    >
      <div className="relative overflow-hidden" style={{ aspectRatio: '3/4' }}>
        <img
          src={comic.cover}
          alt={comic.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
        <div className="absolute top-2 right-2">
          <span
            className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${
              comic.status === 'ongoing'
                ? 'bg-accent-500 text-background-50'
                : 'bg-foreground-600 text-background-50'
            }`}
          >
            {comic.status === 'ongoing' ? '连载中' : '已完结'}
          </span>
        </div>
        <div className="absolute bottom-2 left-2 right-2">
          <div className="flex items-center gap-2 text-xs text-background-50/90">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-eye-line"></i>
            </div>
            <span>{formatViews(comic.views)}</span>
            <div className="w-4 h-4 flex items-center justify-center ml-auto">
              <i className="ri-star-fill text-yellow-400"></i>
            </div>
            <span>{comic.rating}</span>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 whitespace-nowrap">
          {comic.author} · 更新至第{comic.chapters.length}话
        </p>
      </div>
    </Link>
  );
}

function formatViews(views: number): string {
  if (views >= 10000) {
    return (views / 10000).toFixed(1) + '万';
  }
  return views.toString();
}